import { mapGetters } from 'vuex';
import profile from '@/components/account/profile/profile.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import accountDesktopHeader from '@/components/account/account-desktop-header/account-desktop-header.vue';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';

export default {
  components: {
    accountDesktopHeader,
    contentHeader,
    profile,
    staticPageHeader,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    showHeader() {
      return this.$route.name === 'HelpAndSupport';
    },
    gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/support/support/support.js